module.exports = __webpack_public_path__ + "media/guardian_bucket.75b55220.webm";